module.exports = __webpack_public_path__ + "static/img/sbklogo.8d8a61a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sbklogo.jpg
// module id = 431
// module chunks = 1